export const formatPrice = (val: number): string => {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(val).replace(/^(\D+)/, '$1');
};
